/// <amd-module name="Build/DesignerExtensions/YamlSnippetForm/Components/ServiceConnectionPickList" />
import * as React from "react";

import { IListBoxItem } from "VSSUI/ListBox";

import { EnhancedDropdown } from "Build/DesignerExtensions/YamlSnippetForm/Components/EnhancedDropdown";
import { IServiceConnectionProvider } from "Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Types";
import { YamlSnippetInput } from "Pipelines/Common/Library/Contracts/DataProvider";

export interface IServiceConnectionPickListProps {
    inputDefinition: YamlSnippetInput;
    connectionType: string;
    serviceConnectionProvider: IServiceConnectionProvider;
    getValue(name: string): string;
    onValueChanged(name: string, value: string, valueAlias: string): void;
    onError(location: string, error: Error): void;
}

/**
 * Picklist that lists all Service Connections of a particular type such as an Azure Resource Manager connection or a Docker Host connection
 */
export class ServiceConnectionPickList extends React.Component<IServiceConnectionPickListProps, {}> {

    public render(): JSX.Element {
        return <EnhancedDropdown 
            inputDefinition={this.props.inputDefinition} 
            onValueChanged={this.props.onValueChanged} 
            getValue={this.props.getValue} 
            useValueAliases={true}
            loadItems={this._loadConnections}
            loadOnMount={true}
            onError={this.props.onError}
            errorContext={"ServiceConnectionPickList"} />
    }

    private _loadConnections = async (): Promise<IListBoxItem[]> => {
        const connections = await this.props.serviceConnectionProvider.getServiceConnections(this.props.connectionType);

        let items: IListBoxItem[] = [];
        connections.forEach(connection => {
            items.push({
                id: connection.id,
                text: connection.name
            });
        });

        items.sort((a, b) => {
            return a.text!.localeCompare(b.text!, navigator.language);
        });

        return items;
    }
}
